import React, { useRef } from "react";
import styled from "styled-components";
import {
    Button,
    FlexContainer
} from "src/components";
import Dropzone from "react-dropzone";
import CloseIcon from "src/img/CloseButton@2x.png";
import { MediaLimit } from "./NoticeModal";
import { PostTypeAssetPreview } from "./PostTypeAssetPreview";

export const VideoWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const Controls = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background: rgba(0, 0, 0, 0.3);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    height: 40px;
    opacity: 1;
    pointer-events:
`;
const FileInput = styled.input`
    display: none;
`;

const StyledDropzone = styled(Dropzone)`
    position: relative;
    height: ${p => p.previewheight || "12.938rem"} !important;
    width:  ${p => p.previewwidth || "auto"} !important;
    border: 1px solid #8291b2;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 12px;
    margin: ${({ margin }) => margin ?? "0.313rem 0"};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    object-fit: cover;
`;


export const ImagePreview = styled.img`
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-position: 50% 50%;
    object-fit: cover; /* Image will fit inside container without stretching */
    z-index: 1;
    border-radius: 12px;
`;

export const ThumbnailPlaceholderPreview = styled.img`
    width: auto;
    height: auto;
    max-width: 50%;
    max-height: 50%;
    object-position: 50% 50%;
    object-fit: contain; /* Image will fit inside container without stretching */
`;

const RemoveMediaButton = styled.button` 
    display: flex;
    position: absolute;
    z-index: 99999;
    right: -10px;
    top: -10px;
    width: 24px;
    height: 24px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #000000;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: white;
    pointer-events: auto;
`;

const ContainedMediaItemCounter = styled.div` 
    display: flex;
    position: absolute;
    z-index: 2500;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: ${p => p.fontColor ?? "#D8DEEC"};
    margin-top: 11.58px;
    margin-left: 15.49px;
    font-family: roboto;
    font-weight: 300;
    font-size: 14px;
`;

const ExternalMediaItemCounter = styled.div` 
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: ${p => p.fontColor ?? "#D8DEEC"};
    font-family: roboto;
    font-weight: 300;
    font-size: 14px;
    margin-top: 7.41px;
`;

/**
 * @param mediaIndex
 * @param labelChange
 * @param {string} postType
 * @param {NoticeImage|NoticeVideo|undefined} noticeMedia
 * @param onDrop
 * @param onRemove
 * @param previewWidth
 * @param previewHeight
 * @param topPosition
 * @param mediaPreviewSize
 * @returns {Element}
 */
const MediaFileInput = ({
    mediaIndex,
    labelChange = "Change Image/Video",
    postType,
    noticeMedia,
    onDrop,
    onRemove,
    previewWidth,
    previewHeight,
    topPosition,
    mediaPreviewSize,
    trimStart,
    trimEnd,
    crop
}) => {
    const dropzoneRef = useRef(null);
    const fileInputRef = useRef(null);
    const hasMedia = !!noticeMedia;

    const handleDrop = (e) => {
        if (Array.isArray(e)) {
            onDrop(e);
        } else if (e.target.files && e.target.files.length > 0) {
            onDrop(Array.from(e.target.files));
        }
    };

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };

    const handleRemoveAttachment = () => {
        onRemove();
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    return (
        <FlexContainer>
            <FlexContainer>
                <div style={{
                    display: "flex",
                    width: "100%",
                    height: "10%",
                    flexDirection: "row",
                    position: "relative"
                }}>
                    <FlexContainer
                        width="50%"
                        height="20%"
                    >
                        {
                            mediaIndex === 0 &&
                            <ContainedMediaItemCounter fontColor={hasMedia ? "#FFF" : "#D8DEEC"}>1 of {MediaLimit}</ContainedMediaItemCounter>
                        }
                    </FlexContainer>
                </div>
                <StyledDropzone
                    ref={dropzoneRef}
                    onDrop={handleDrop}
                    previewwidth={previewWidth}
                    previewheight={previewHeight}
                    margin={mediaIndex !== 0 ? "0" : "0.313rem 0"}
                >
                    <PostTypeAssetPreview
                        postType={postType}
                        noticeMedia={noticeMedia}
                        trimTimeStart={trimStart}
                        trimTimeEnd={trimEnd}
                        crop={crop}
                        mediaIndex={mediaIndex}
                    />
                    {hasMedia &&
                        <RemoveMediaButton onClick={handleRemoveAttachment} topPosition={topPosition}>
                            <img src={CloseIcon} alt="close button" width={24} height={24} />
                        </RemoveMediaButton>
                    }
                </StyledDropzone>
                {mediaIndex !== 0 &&
                    <ExternalMediaItemCounter>{mediaIndex + 1} of {MediaLimit}</ExternalMediaItemCounter>
                }
            </FlexContainer>

            <FileInput
                type="file"
                accept="image/*,video/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleDrop}
                multiple
            />

            {mediaIndex === 0 && !hasMedia &&
                <FlexContainer direction="row" justifyContent="space-between">
                    <Button
                        backgroundColor={"#000"}
                        border={hasMedia ? "1px solid #000" : undefined}
                        color={"#FFF"}
                        width="9.35rem"
                        height="2.375rem"
                        padding="unset !important"
                        style={{ borderRadius: "7px", marginTop: "10px" }}
                        onClick={handleBrowseClick}
                    >
                        {hasMedia ? labelChange : "Browse File"}
                    </Button>
                </FlexContainer>
            }
        </FlexContainer>
    );
};

export default MediaFileInput;
